//#region src/core/source/cloudflare.ts
/**
* Extract a Cloudflare video UID from a raw UID, a signed token, or any recognized URL.
*
* @internal
*/
function parseCloudflareVideoId(src) {
	return parseCloudflareSource(src)?.id ?? null;
}
/**
* Parse a Cloudflare Stream source string. Recognizes `videodelivery.net` and `cloudflarestream.com` URLs (embed,
* iframe, manifest, and thumbnail paths all carry the id in the same position), raw 32-character video UIDs, and signed
* tokens, which stand in for the UID wherever it appears.
*
* @internal
*/
function parseCloudflareSource(src) {
	if (!src) return null;
	const id = MATCH_SRC.exec(src)?.[1] ?? (MATCH_VIDEO_ID.test(src) || MATCH_SIGNED_TOKEN.test(src) ? src : null);
	if (!id) return null;
	return {
		id,
		signed: MATCH_SIGNED_TOKEN.test(id),
		origin: MATCH_CUSTOMER_ORIGIN.exec(src)?.[1] ?? null
	};
}
const MATCH_SRC = /(?:cloudflarestream\.com|videodelivery\.net)\/([\w-.]+)/i;
const MATCH_CUSTOMER_ORIGIN = /^(https?:\/\/customer-[\w-]+\.cloudflarestream\.com)/i;
const MATCH_VIDEO_ID = /^[a-z\d]{32}$/i;
const MATCH_SIGNED_TOKEN = /^[\w-]+\.[\w-]+\.[\w-]+$/;
//#endregion
export { parseCloudflareSource, parseCloudflareVideoId };

//# sourceMappingURL=cloudflare.js.map